import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
  container: {
    paddingLeft: 25,
    width: '100%',
  },
}));